import CommonService from "./services/common.service";
import React from "react";

import EU from "./assets/img/source-flags/EU.svg";
import TR from "./assets/img/source-flags/TR.svg";
import UN from "./assets/img/source-flags/UN.png";
import IN from "./assets/img/flags/india.svg";
import SG from "./assets/img/source-flags/SG.png";
import PK from "./assets/img/flags/pakistan.svg";
import SPK from "./assets/img/source-flags/SPK.png";
import RU from "./assets/img/flags/russia.svg";
import TMSF from "./assets/img/source-flags/TMSF.png";
import MASAK from "./assets/img/source-flags/MASAK.png";
import EMPTY_AVATAR from './assets/img/empty-avatar.png'
import INT from "./assets/img/source-flags/INT.png";
import CSL from "./assets/img/source-flags/CSL.png";
import OFAC from "./assets/img/source-flags/OFAC.png";
import SWISS from "./assets/img/flags/switzerland.svg";
import WORLD_BANK from "./assets/img/source-flags/world-bank.png";
import AU from "./assets/img/flags/australia.svg";
import CA from "./assets/img/flags/canada.svg";
import UA from "./assets/img/flags/ukraine.svg";
import KG from "./assets/img/source-flags/KG.png";
import ZA from "./assets/img/flags/south-africa.svg";
import FR from "./assets/img/flags/france.svg";
import UK from "./assets/img/flags/united-kingdom.svg";
import FATF from "./assets/img/source-flags/FATF.png";
import AE from "./assets/img/flags/united-arab-emirates.svg"
import IL from "./assets/img/flags/israel.svg"
import AZ from "./assets/img/flags/azerbaijan.svg"
import JP from "./assets/img/flags/japan.svg"
import NZ from "./assets/img/flags/new-zealand.svg"
import BE from "./assets/img/flags/belgium.svg"


import ReactGA from "react-ga"
import AuthService from "./services/auth.service";
import moment from "moment";


export const MATCH_RATE_SLIDER_MARKS = {
    60: '60%',
    100: {
        style: {
            color: '#204f79',
        },
        label: <strong>100%</strong>,
    },
};

export function minMatchRateFormatter(value) {
    return `Min %${value}`;
}

export function izFalse(bool) {
    return !izTrue(bool);
}

export function izTrue(bool) {
    return izNotBlank(bool) && ((typeof a === 'string' && "true" === bool.toLowerCase()) || true === bool);
}

export function izNotBlank(str) {
    return !!str && str !== "" && str !== "null";
}

export function izBlank(str) {
    return !izNotBlank(str);
}

export function getAsStr(value) {
    return value === undefined || !value ? "" : value.toString();
}

export function izNotEmpty(arr) {
    return !izEmpty(arr);
}

export function izEmpty(arr) {
    return !arr || !arr.length || arr.length === 0
}

export const DEFAULTS = {
    txLevelColors: [
        'red',
        'red', 'orange', 'green', 'green', 'green',
        'green', 'green', 'green', 'green', 'green',
        'green', 'green', 'green', 'green', 'green',
    ],
    customerLevelColors: [
        'red',
        'red', 'orange', 'green', 'green', 'green',
        'green', 'green', 'green', 'green', 'green',
        'green', 'green', 'green', 'green', 'green',
    ],
}

export const DEFAULT_USER_STATE = {
    accessToken: "",
    username: "",
    password: "",
    login_error: "",
    loading: false
}

export const CHANGE_CURRENCY = "CHANGE_CURRENCY";
export const CHANGE_LANG = "CHANGE_LANG";
export const CHANGE_TX_RISK_LEVELS = "CHANGE_TX_RISK_LEVELS";
export const CHANGE_CUSTOMER_RISK_LEVELS = "CHANGE_CUSTOMER_RISK_LEVELS";

export const DEFAULT_COMMON_STATE = {
    currency: CommonService.getCurrency(),
    lang: CommonService.getLang(),
    txRiskLevels: CommonService.getTxRiskLevels(),
    customerRiskLevels: CommonService.getCustomerRiskLevels()
}

export const DEFAULT_SEARCH_STATE = {
    activeTab: 0,
    searchResults: [],
    includeAdverseMedia: false,
    additionalMediaLinks: [],
    itemType: "Individual",
    switch: false,
    identification: "",
    fullName: "",
    placeOfBirth: "",
    birthDate: ""
}

export const ADD_ACCESS_TOKEN = "ADD_ACCESS_TOKEN";
export const LOG_OUT = "LOG_OUT";

export const ACTIVE_TAB = "ACTIVE_TAB";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";

export const scriptRegex = /(<([^>]+)>)/ig

export const AVAILABLE_LANGUAGES = ["tr", "en"]

export const ENVIRONMENT = process.env.REACT_APP_ENV
export const IS_PROD = ENVIRONMENT === 'prod'
export const IS_SANDBOX = ENVIRONMENT === 'sandbox'
export const IS_LOCAL = ENVIRONMENT === 'local'

export const GA_TRACING_ID = IS_PROD ? "UA-190210625-1" : ""
export const GA_LOCAL_STORAGE_KEY = "ga:clientId"
export const initGA = () => {
    ReactGA.initialize(GA_TRACING_ID, {
        'storage': 'none',
        'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
    });
    ReactGA.ga((tracker) => {
        localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
    });

    ReactGA.set({subdomain: "kurumsal"})
}
export const gaSet = (accountId) => {
    ReactGA.set({userId: accountId})
}
export const gaPageView = () => {
    let path = window.location.pathname + window.location.search;
    ReactGA.pageview(path)
}
export const gaPageViewByPath = (path) => {
    ReactGA.pageview(path)
}
export const gaEvent = (action, label) => {
    let category = window.location.pathname + window.location.search;
    ReactGA.event({
        category: category,
        action: action,
        label: label
    })
}
export const gaEventWithUserIdLabel = (action) => {
    let category = window.location.pathname + window.location.search;
    ReactGA.event({
        category: category,
        action: action,
        label: AuthService.getCurrentUserUniqueId()
    })
}

const dev = {
    API_URL: IS_PROD ? 'https://kurumsal.searchsanctions.com/api/api/' : (IS_SANDBOX ? 'https://sandbox-kurumsal.searchsanctions.com/api/api/' : 'http://localhost:8887/api/api/'),
    AUTH_URL: IS_PROD ? 'https://kurumsal.searchsanctions.com/api/auth/' : (IS_SANDBOX ? 'https://sandbox-kurumsal.searchsanctions.com/api/auth/' : 'http://localhost:8887/api/auth/')
}

export const mainPage = ["login", "forgetPassword"]

export const config = dev

export function getPackageEndDate(period) {
    return moment(new Date()).add(period, 'months').add(1, 'days')
}

export function uniqueArray(array) {

    let fresh = {};

    array.forEach(function (v) {
        fresh[v + '::' + typeof v] = v;
    });

    return Object.keys(fresh).map(function (v) {
        return fresh[v];
    });
}

export function getCardClassNames(packageType) {
    let className = "current-package mb-30 d-flex justify-content-center"

    if (packageType === "FREE") className += " custom-card-border-free"
    if (packageType === "STANDARD") className += " custom-card-border-standard"
    if (packageType === "GOLD") className += " custom-card-border-gold"
    if (packageType === "PLATINUM") className += " custom-card-border-platinum"

    return className
}

export function getTitleClassName(packageType) {
    if (packageType === "FREE") return "pkg-free"
    if (packageType === "GOLD") return "pkg-gold"
    if (packageType === "PLATINUM") return "pkg-platinum"

    return "pkg-standard"
}

export function getDetailClassName(packageType) {
    if (packageType === "FREE") return "current-package-detail-free"
    if (packageType === "GOLD") return "current-package-detail-gold"
    if (packageType === "PLATINUM") return "current-package-detail-platinum"

    return "current-package-detail-standard"
}

export function validateEmail(mail) {
    let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(mail).toLowerCase());
}

export function escapeTurkishChars(text) {

    if (!text) return ""

    return text
        .replaceAll("ş", "s").replaceAll("Ş", "S")
        .replaceAll("ı", "i").replaceAll("İ", "I")
        .replaceAll("ç", "c").replaceAll("Ç", "C")
        .replaceAll("ö", "o").replaceAll("Ö", "O")
        .replaceAll("ğ", "g").replaceAll("Ğ", "G")
        .replaceAll("ü", "u").replaceAll("Ü", "U");
}

export function getCountryCode(name) {
    let countries = COUNTRIES.filter(c => c.name === name);
    return countries.length ? countries[0].code : "";
}

export function getCountry(code) {
    if (izBlank(code) || code.length !== 2) return "";
    let countries = COUNTRIES.filter(c => c.code === code);
    return countries.length ? countries[0].name : code;
}

export function sourceFlag(source, defaultFlag) {

    let detectedFlag = getSourceFlag(source)
    if (izBlank(detectedFlag)) {
        if (izBlank(defaultFlag)) {
            return TR
        }
        try {
            return require('./assets/img/' + defaultFlag);
        } catch (e) {
            return TR
        }
    }
    return detectedFlag
}

export function getSourceFlag(source) {
    switch (source) {
        case "PK":
            return PK
        case "RU":
            return RU
        case "BE":
            return BE
        case "NZ":
            return NZ
        case "JP":
            return JP
        case "AE":
            return AE
        case "AZ":
            return AZ
        case "IL":
            return IL
        case "IN":
            return IN
        case "PEP":
            return EMPTY_AVATAR
        case "MASAK":
            return MASAK
        case "SWISS":
            return SWISS
        case "WORLD_BANK":
            return WORLD_BANK
        case "AU":
            return AU
        case "SPK":
            return SPK
        case "TMSF":
            return TMSF
        case "SG":
            return SG
        case "EU":
            return EU
        case "UN":
            return UN
        case "UA":
            return UA
        case "KG":
            return KG
        case "ZA":
            return ZA
        case "FR":
            return FR
        case "UK":
            return UK
        case "CA":
            return CA
        case "INTERPOL":
            return INT
        case "CSL":
            return CSL
        case "FATF":
        case "RISKY_COUNTRIES":
            return FATF
        case "OFAC_SDN":
        case "OFAC_NON_SDN":
            return OFAC
        default:
            return null
    }
}

export const COUNTRIES = [
    {"code": "AF", "name": "Afghanistan"},
    {"code": "AL", "name": "Albania"},
    {"code": "DZ", "name": "Algeria"},
    {"code": "AS", "name": "American Samoa, United States"},
    {"code": "AD", "name": "Andorra"},
    {"code": "AO", "name": "Angola"},
    {"code": "AI", "name": "Anguilla, United Kingdom"},
    {"code": "AG", "name": "Antigua and Barbuda"},
    {"code": "AR", "name": "Argentina"},
    {"code": "AM", "name": "Armenia"},
    {"code": "AU", "name": "Australia"},
    {"code": "AT", "name": "Austria"},
    {"code": "AZ", "name": "Azerbaijan"},
    {"code": "BS", "name": "Bahamas"},
    {"code": "BH", "name": "Bahrain"},
    {"code": "BD", "name": "Bangladesh"},
    {"code": "BB", "name": "Barbados"},
    {"code": "BY", "name": "Belarus"},
    {"code": "BE", "name": "Belgium"},
    {"code": "BZ", "name": "Belize"},
    {"code": "BJ", "name": "Benin"},
    {"code": "BT", "name": "Bhutan"},
    {"code": "BO", "name": "Bolivia"},
    {"code": "BA", "name": "Bosnia and Herzegovina"},
    {"code": "BW", "name": "Botswana"},
    {"code": "BR", "name": "Brazil"},
    {"code": "BN", "name": "Brunei "},
    {"code": "BG", "name": "Bulgaria"},
    {"code": "BF", "name": "Burkina Faso"},
    {"code": "BI", "name": "Burundi"},
    {"code": "KH", "name": "Cambodia"},
    {"code": "CM", "name": "Cameroon"},
    {"code": "CA", "name": "Canada"},
    {"code": "CV", "name": "Cape Verde"},
    {"code": "CF", "name": "Central African Republic"},
    {"code": "TD", "name": "Chad"},
    {"code": "CL", "name": "Chile"},
    {"code": "CN", "name": "China"},
    {"code": "CO", "name": "Colombia"},
    {"code": "KM", "name": "Comoros"},
    {"code": "CG", "name": "Congo"},
    {"code": "CD", "name": "Democratic Republic of Congo"},
    {"code": "CR", "name": "Costa Rica"},
    {"code": "HR", "name": "Croatia"},
    {"code": "CU", "name": "Cuba"},
    {"code": "CY", "name": "Cyprus"},
    {"code": "CZ", "name": "Czech Republic"},
    {"code": "CI", "name": "Côte d'Ivoire"},
    {"code": "DK", "name": "Denmark"},
    {"code": "DJ", "name": "Djibouti"},
    {"code": "DM", "name": "Dominica"},
    {"code": "DO", "name": "Dominican Republic"},
    {"code": "EC", "name": "Ecuador"},
    {"code": "EG", "name": "Egypt"},
    {"code": "SV", "name": "El Salvador"},
    {"code": "GQ", "name": "Equatorial Guinea"},
    {"code": "ER", "name": "Eritrea"},
    {"code": "EE", "name": "Estonia"},
    {"code": "SZ", "name": "Eswatini"},
    {"code": "ET", "name": "Ethiopia"},
    {"code": "FJ", "name": "Fiji"},
    {"code": "FI", "name": "Finland"},
    {"code": "FR", "name": "France"},
    {"code": "GA", "name": "Gabon"},
    {"code": "GM", "name": "Gambia"},
    {"code": "GE", "name": "Georgia"},
    {"code": "DE", "name": "Germany"},
    {"code": "GH", "name": "Ghana"},
    {"code": "GR", "name": "Greece"},
    {"code": "GD", "name": "Grenada"},
    {"code": "GT", "name": "Guatemala"},
    {"code": "GN", "name": "Guinea"},
    {"code": "GW", "name": "Guinea Bissau"},
    {"code": "GY", "name": "Guyana"},
    {"code": "HT", "name": "Haiti"},
    {"code": "HN", "name": "Honduras"},
    {"code": "HK", "name": "Hong Kong"},
    {"code": "HU", "name": "Hungary"},
    {"code": "ICC", "name": "International Criminal Court"},
    {"code": "IS", "name": "Iceland"},
    {"code": "IN", "name": "India"},
    {"code": "ID", "name": "Indonesia"},
    {"code": "IR", "name": "Iran"},
    {"code": "IQ", "name": "Iraq"},
    {"code": "IE", "name": "Ireland"},
    {"code": "IL", "name": "Israel"},
    {"code": "IT", "name": "Italy"},
    {"code": "JM", "name": "Jamaica"},
    {"code": "JP", "name": "Japan"},
    {"code": "JO", "name": "Jordan"},
    {"code": "KZ", "name": "Kazakhstan"},
    {"code": "KE", "name": "Kenya"},
    {"code": "KI", "name": "Kiribati"},
    {"code": "KP", "name": "Democratic People's Republic of Korea"},
    {"code": "KR", "name": "Republic of Korea"},
    {"code": "KW", "name": "Kuwait"},
    {"code": "KG", "name": "Kyrgyzstan"},
    {"code": "KY", "name": "Cayman Islands"},
    {"code": "LA", "name": "Laos"},
    {"code": "LV", "name": "Latvia"},
    {"code": "LB", "name": "Lebanon"},
    {"code": "LS", "name": "Lesotho"},
    {"code": "LR", "name": "Liberia"},
    {"code": "LY", "name": "Libya"},
    {"code": "LI", "name": "Liechtenstein"},
    {"code": "LT", "name": "Lithuania"},
    {"code": "LU", "name": "Luxembourg"},
    {"code": "MO", "name": "Macao, China"},
    {"code": "MG", "name": "Madagascar"},
    {"code": "MW", "name": "Malawi"},
    {"code": "MY", "name": "Malaysia"},
    {"code": "MV", "name": "Maldives"},
    {"code": "ML", "name": "Mali"},
    {"code": "MT", "name": "Malta"},
    {"code": "MH", "name": "Marshall Islands"},
    {"code": "MR", "name": "Mauritania"},
    {"code": "MU", "name": "Mauritius"},
    {"code": "MX", "name": "Mexico"},
    {"code": "FM", "name": "Micronesia, Federated States of"},
    {"code": "MD", "name": "Moldova"},
    {"code": "MC", "name": "Monaco"},
    {"code": "MN", "name": "Mongolia"},
    {"code": "ME", "name": "Montenegro"},
    {"code": "MA", "name": "Morocco"},
    {"code": "MZ", "name": "Mozambique"},
    {"code": "MM", "name": "Myanmar"},
    {"code": "NA", "name": "Namibia"},
    {"code": "NR", "name": "Nauru"},
    {"code": "NP", "name": "Nepal"},
    {"code": "NL", "name": "Netherlands"},
    {"code": "NZ", "name": "New Zealand"},
    {"code": "NI", "name": "Nicaragua"},
    {"code": "NE", "name": "Niger"},
    {"code": "NG", "name": "Nigeria"},
    {"code": "MK", "name": "North Macedonia"},
    {"code": "NO", "name": "Norway"},
    {"code": "OM", "name": "Oman"},
    {"code": "PK", "name": "Pakistan"},
    {"code": "PW", "name": "Palau"},
    {"code": "PS", "name": "Palestine, State of"},
    {"code": "PA", "name": "Panama"},
    {"code": "PG", "name": "Papua New Guinea"},
    {"code": "PY", "name": "Paraguay"},
    {"code": "PE", "name": "Peru"},
    {"code": "PH", "name": "Philippines"},
    {"code": "PL", "name": "Poland"},
    {"code": "PT", "name": "Portugal"},
    {"code": "QA", "name": "Qatar"},
    {"code": "RO", "name": "Romania"},
    {"code": "RU", "name": "Russia"},
    {"code": "RW", "name": "Rwanda"},
    {"code": "KN", "name": "Saint Kitts and Nevis"},
    {"code": "LC", "name": "Saint Lucia"},
    {"code": "VC", "name": "Saint Vincent and the Grenadines"},
    {"code": "WS", "name": "Samoa"},
    {"code": "SM", "name": "San Marino"},
    {"code": "ST", "name": "Sao Tome and Principe"},
    {"code": "SA", "name": "Saudi Arabia"},
    {"code": "SN", "name": "Senegal"},
    {"code": "RS", "name": "Serbia"},
    {"code": "SC", "name": "Seychelles"},
    {"code": "SL", "name": "Sierra Leone"},
    {"code": "SG", "name": "Singapore"},
    {"code": "SK", "name": "Slovakia"},
    {"code": "SI", "name": "Slovenia"},
    {"code": "SB", "name": "Solomon Islands"},
    {"code": "SO", "name": "Somalia"},
    {"code": "ZA", "name": "South Africa"},
    {"code": "SS", "name": "South Sudan"},
    {"code": "ES", "name": "Spain"},
    {"code": "LK", "name": "Sri Lanka"},
    {"code": "STL", "name": "Special Tribunal for Lebanon"},
    {"code": "SD", "name": "Sudan"},
    {"code": "SR", "name": "Suriname"},
    {"code": "SE", "name": "Sweden"},
    {"code": "CH", "name": "Switzerland"},
    {"code": "SY", "name": "Syria"},
    {"code": "TJ", "name": "Tajikistan"},
    {"code": "TZ", "name": "Tanzania"},
    {"code": "TH", "name": "Thailand"},
    {"code": "TL", "name": "Timor-Leste"},
    {"code": "TG", "name": "Togo"},
    {"code": "TO", "name": "Tonga"},
    {"code": "TT", "name": "Trinidad and Tobago"},
    {"code": "TN", "name": "Tunisia"},
    {"code": "TR", "name": "Türkiye"},
    {"code": "TM", "name": "Turkmenistan"},
    {"code": "TC", "name": "Turks and Caicos"},
    {"code": "TV", "name": "Tuvalu"},
    {"code": "UG", "name": "Uganda"},
    {"code": "UA", "name": "Ukraine"},
    {"code": "IRMCT", "name": "United Nations International Residual Mechanism for Criminal Tribunals"},
    {"code": "UNK", "name": "Republic of Kosovo"},
    {"code": "AE", "name": "United Arab Emirates"},
    {"code": "GB", "name": "United Kingdom"},
    {"code": "US", "name": "United States"},
    {"code": "UY", "name": "Uruguay"},
    {"code": "UZ", "name": "Uzbekistan"},
    {"code": "VU", "name": "Vanuatu"},
    {"code": "VA", "name": "Vatican City State"},
    {"code": "VE", "name": "Venezuela"},
    {"code": "VN", "name": "Viet Nam"},
    {"code": "YE", "name": "Yemen"},
    {"code": "ZM", "name": "Zambia"},
    {"code": "ZW", "name": "Zimbabwe"},
    {"code": "GI", "name": "Gibraltar"},
    {"code": "VG", "name": "Virgin Islands"},
    {"code": "TW", "name": "Taiwan"},
    {"code": "AW", "name": "Aruba"},
    {"code": "NM", "name": "New Mexico"},
    {"code": "PRC", "name": "People's Republic of China"},
    {"code": "GG", "name": "Guernsey"},
    {"code": "JE", "name": "Jersey"}
]
